import Header from "./components/header/Header";

const App = () => {
  return (
    <>
      <Header />
    </>
  );
};

export default App;
